import 'moment/locale/nb';
import React from 'react';
import {
  getBrandingText,
  getBrandingContactInformation,
  contactInformationTypes,
} from 'src/branding';
import { RegNotAvailible } from './Components';

export const LoadingErrorMessage = () => (
  <RegNotAvailible>
    <h2 style={{ marginTop: '1.7em' }}>Kunne ikke laste inn data.</h2>
    <p style={{ fontWeight: 'bold' }}>Mulige årsaker</p>
    <ul>
      <li>Det oppsto en feil ved innlasting av dataen.</li>
      <li>
        En eller flere tjenester som blir benyttet er midlertidig
        utilgjengelige.
      </li>
      <li>Du er ikke registrert i Mattilsynets Produsentregister</li>
    </ul>

    <p style={{ marginTop: '1.5em' }}>
      Ta kontakt med
      {' '}
      {getBrandingText('companyName')}
      {' '}
      på tlf
      {' '}
      {getBrandingContactInformation(contactInformationTypes.errorLoadingEnrolmentPageContactPhone)}
      {' '}
      hvis problemet vedvarer
    </p>
  </RegNotAvailible>
);
